import React, { useEffect, useState } from "react";
import { Text, Flex, Table, Provider } from "@fluentui/react-northstar";
import PropTypes from "prop-types";
import { observer } from "mobx-react-lite";
import AgentStatus from "../AgentStatus";
import AgentTeamsList from "../AgentTeamsList";

const TeamMembers = observer((props) => {
  const { agents } = props;

  const [state, setState] = useState({});

  useEffect(() => {
    // Set timer to update the call timer
    const timerId = setInterval(() => {
      // update TeamMembers - force re-render.....
      setState((prevState) => ({ ...prevState, state }));
    }, 10000);

    return () => {
      clearInterval(timerId);
    };
  });

  const renderAgentData = () => {
    // Sort the agent list first
    const sortedAgents = [...agents].sort((a, b) => {
      return a.fullName.localeCompare(b.fullName);
    });

    return sortedAgents.map((agent) => {
      return {
        key: agent.id,
        style: { height: "auto", paddingTop: "5px", paddingBottom: "5px" },
        items: [
          {
            content: (
              <Text data-testid="rowAgentFullName">{agent.fullName}</Text>
            ),
            key: agent.id + "- AgentName",
          },
          {
            content: (
              <AgentStatus
                data-testid="rowAgentStatus"
                statusCode={agent.statusCode}
                reasonCode={agent.reasonCode}
                statusChangeTime={agent.statusChangeTime}
              />
            ),
            key: agent.id + "- AgentStatus",
          },
          {
            content: (
              <AgentTeamsList data-testid="rowAgentTeamsList" agent={agent} />
            ),
            key: agent.id + "- AgentTeams",
          },
        ],
      };
    });
  };

  const agentData = renderAgentData();

  return (
    <Provider.Consumer
      render={(theme) => (
        <Flex gap="gap.small" data-testid="teamMembers" className="team-members">
          <Table
            data-testid="teamMembersTable"
            className={"team-members-table " + theme.siteVariables.themeString}
            rows={agentData}
          />
        </Flex>
      )}
    ></Provider.Consumer>
  );
});

TeamMembers.propTypes = {
  agents: PropTypes.array,
};

TeamMembers.defaultProps = {
  agents: [],
};

export default TeamMembers;
